import { type StateCreator } from 'zustand';

export type ReactQueryDevtoolsVisibleSlice = {
  reactQueryDevtoolsVisible: boolean;
  setReactQueryDevtoolsVisible: (reactQueryDevtoolsVisible: boolean) => void;
  toggleReactQueryDevtoolsVisible: () => void;
};

type CreateReactQueryDevtoolsVisibleSlice = (
  initialState: Pick<ReactQueryDevtoolsVisibleSlice, 'reactQueryDevtoolsVisible'>,
) => StateCreator<ReactQueryDevtoolsVisibleSlice, [], [], ReactQueryDevtoolsVisibleSlice>;

export const createReactQueryDevtoolsVisibleSlice: CreateReactQueryDevtoolsVisibleSlice = (initialState) => (set) => ({
  reactQueryDevtoolsVisible: initialState.reactQueryDevtoolsVisible ?? false,
  setReactQueryDevtoolsVisible: (reactQueryDevtoolsVisible: boolean) => set({ reactQueryDevtoolsVisible }),
  toggleReactQueryDevtoolsVisible: () =>
    set((state) => ({ reactQueryDevtoolsVisible: !state.reactQueryDevtoolsVisible })),
});
